module.exports = __webpack_public_path__ + "img/faq_mens_on_click.1b7747f8.jpg";